import sportModule, { ISportResultsState } from './sport';
import lottoModule, { ILottoResultsState } from './lotto';
import specialEventsModule, { ISpecialEventResultsState } from './special';

export interface IResultsState {
    sport: ISportResultsState;
    lotto: ILottoResultsState;
    special: ISpecialEventResultsState;
}

export default {
    namespaced: true,
    modules: {
        specials: specialEventsModule,
        sport: sportModule,
        lotto: lottoModule,
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/data/results/resultsIndex.ts